import {Component, OnInit} from '@angular/core';
import {Constants} from '../../../shared/utils/constants';
import {AffiliateService} from '../affiliate.service';
import {AppService} from '../../../app.service';
import {Permission} from '../../../models/permission.model';

@Component({
  selector: 'fx-manage-setting',
  templateUrl: './manage-setting.component.html',
  styleUrls: ['./manage-setting.component.sass']
})
export class ManageSettingComponent implements OnInit {
  permission: Permission;
  listConfig = [];

  constructor(
    private appService: AppService,
    private service: AffiliateService) {
    this.getListGroupConfig();
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
  }

  private getListGroupConfig(): void {
    this.service.getGroupConfigs({})
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listConfig = res.data;
        }
      });
  }

}
